var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaleNurse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.302 87.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "male_nurse-01",
    "data-name": "male nurse-01",
    transform: "translate(-43.549 -34.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M46.5,95.9,44,108.1l8.3,2.5,5.1-1.8,4.9-1.9.7-9.4S57.7,96,57.5,96c-.1,0-4.8-.5-4.8-.5Z",
    fill: "#fff",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M100.8,95.9l2.5,12.2L95,110.6l-5.1-1.8L85,106.9l-.7-9.4S89.6,96,89.8,96c.1,0,4.8-.5,4.8-.5Z",
    fill: "#fff",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M54,116.7l-.2,5.2H91.2L89.9,97l13-.4C100.2,84.5,96,77.4,96,77.4,89.4,72.2,73.3,71,73.3,71c-13.2,1.8-20.6,6.4-20.6,6.4C46.6,84.5,44.3,98,44.3,98l12.6,1.7Z",
    fill: "#7befd0",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M68.7,64.2a14.919,14.919,0,0,0,2.1.2A31.056,31.056,0,0,0,79.5,63c.3,4.2.8,8.9,1.8,10.8,1.9,3.8-8.6,3.5-8.6,3.5s-9-.3-6.6-3.8C68.3,70.2,68.6,65.3,68.7,64.2Z",
    fill: "#f5caa2",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M77,67.8a7.719,7.719,0,0,1-5.4,0,10.856,10.856,0,0,1-3-1.8c.5-2.4.2-2.1.2-2.1l10.5-8.5s0,5.3.6,10.7C79,67,79,67.1,77,67.8Z",
    fill: "#161b43"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M61.6,54.2c0-2,.6-3.6,1.8-3.6a1.952,1.952,0,0,1,.7.1,7.967,7.967,0,0,0-.1-1.1v-.2h0V47.8a.367.367,0,0,1,.1-.3v-.1a.367.367,0,0,1,.1-.3V47c0-.1.1-.2.1-.3v-.1c0-.1.1-.2.1-.3v-.1c0-.1.1-.2.1-.4v-.1c0-.1.1-.2.1-.4v-.1c0-.1.1-.2.1-.4v-.1c.1-.1.1-.2.2-.4v-.1c.1-.1.1-.2.2-.4a.1.1,0,0,1,.1-.1c.1-.1.1-.2.2-.4a.1.1,0,0,1,.1-.1.52.52,0,0,0,.2-.4.1.1,0,0,1,.1-.1l.3-.3.1-.1.3-.3.1-.1.3-.3.1-.1.3-.3.1-.1.3-.3.1-.1a.52.52,0,0,1,.4-.2c.1,0,.1-.1.2-.1a.758.758,0,0,1,.4-.2c.1,0,.1-.1.2-.1.1-.1.3-.1.4-.2.1,0,.1-.1.2-.1.1-.1.3-.1.4-.2.1,0,.1-.1.2-.1a.6.6,0,0,1,.4-.1.349.349,0,0,0,.2-.1c.2,0,.3-.1.5-.1a.367.367,0,0,0,.3-.1c.2,0,.3-.1.5-.1h.3a1.268,1.268,0,0,0,.6-.1h3.2a.9.9,0,0,1,.5.1.367.367,0,0,1,.3.1c.1,0,.3.1.4.1a.367.367,0,0,1,.3.1c.1,0,.3.1.4.1s.2.1.3.1.3.1.4.1a.349.349,0,0,1,.2.1c.1.1.2.1.4.2.1,0,.1.1.2.1.1.1.2.1.4.2.1,0,.1.1.2.1a.52.52,0,0,0,.4.2l.1.1c.1.1.3.2.4.3h0a3.044,3.044,0,0,1,.8.8.1.1,0,0,0,.1.1l.3.3.1.1c.1.1.2.2.2.3l.1.1c.1.1.1.2.2.3l.1.1c.1.1.1.2.2.3l.1.1c.1.1.1.2.2.3a.1.1,0,0,0,.1.1c.1.1.1.2.2.3a.1.1,0,0,0,.1.1.367.367,0,0,1,.1.3v.1c.1.1.1.2.1.4v.1l.3.9h0c0,.1.1.3.1.4v.1a.367.367,0,0,0,.1.3v1.7h0v.7a5.384,5.384,0,0,1-.1,1.1,6.374,6.374,0,0,1,.7-.2c1.3,0,1.9,1.6,1.9,3.6A3.977,3.977,0,0,1,84,57.3a18.162,18.162,0,0,1-.8,4.2c-1.2,3-5.7,5.3-8.7,5.4a10.973,10.973,0,0,1-9-5.1,12.54,12.54,0,0,1-.9-4.1A3.874,3.874,0,0,1,61.6,54.2Z",
    fill: "#f5caa2",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M83.8,73.4c-.1,0-.3-.1-.4-.1s-.1,0-.2-.1h-.3c.7,1.1.9,2.1.4,2.9-1.8,3.4-12.4,3.1-12.5,3.1-3.7,0-6-.7-6.7-2.2s.6-3.5.8-3.8c-.1,0-.2,0-.2.1h-.1a.1.1,0,0,0-.1.1c-.2.1-.3.1-.5.2a4.263,4.263,0,0,0-.4,3.7c.8,1.7,3.2,2.6,7.3,2.5h1.3c3,0,10.2-.5,11.7-3.4A2.945,2.945,0,0,0,83.8,73.4Z",
    fill: "#4ba0a0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M66.5,47.1S64.6,53.2,64.8,58l-1-7.1s-1.4-1.8.1-2.8l1.4-1.7.6-.1.4.1Z",
    fill: "#2c355e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M82.3,46.4s1.9,7.1,1.7,11.8l1.1-8s1.3-1.9-.2-2.8l-1.4-1.6-.6-.1-.4.1Z",
    fill: "#2c355e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M64,48.2s7.6-5.4,20.6-.7c0,0,4.2-5.5.4-9.8C81.2,33.3,70.6,35,70.6,35S56.5,36,64,48.2Z",
    fill: "#7befd0",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M66.9,72l.5-1.3-.5.1a7.088,7.088,0,0,0-4.5,3.4c-3.2,5.6-.5,15.3-.4,15.8l1.2-.3c0-.1-2.7-9.7.3-14.8a5.385,5.385,0,0,1,3.4-2.7c-.1-.1-.1-.1,0-.2v.1C66.8,72.1,66.8,72.1,66.9,72Z",
    fill: "#fff",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M61.5,105.5a13.3,13.3,0,0,1-2.1-5.7c-.6-4.6,1.1-8.8,3.7-9.1S68.4,94,69,98.6a11.941,11.941,0,0,1-.8,6.4,6.47,6.47,0,0,1,.8.9,12.764,12.764,0,0,0,1-7.5c-.7-5.4-3.8-9.3-7.1-8.9s-5.3,5-4.6,10.4a13.641,13.641,0,0,0,2.5,6.6A3.591,3.591,0,0,1,61.5,105.5Z",
    fill: "#fff",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M61.1,92.5l-1.8-1.1a4.794,4.794,0,0,1,7.2-1.3l-1.2,1.7a3.1,3.1,0,0,0-2.3-.7A3.54,3.54,0,0,0,61.1,92.5Z",
    fill: "#2c355e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M79.9,97.1l-1.1-.6,3-6.2c0-.1,5-11.1,2.5-15.9a4,4,0,0,0-3.3-2L80.7,71a6.859,6.859,0,0,1,4.7,2.9c2.8,5.4-2.3,16.6-2.5,17Z",
    fill: "#fff",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M81.4,99.1a3,3,0,0,0-2-2.6,3.07,3.07,0,0,0-3.3.5Z",
    fill: "#2c355e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M74.2,51.4l1.6,5.3s.1,1.2-1,1.3H73.1",
    fill: "none",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M81.1,64.7c-2.2-1.1.1-5.2-4.5-5.6s-7,0-7.1,3.1c0,1.3-1.1,2.7-1.5,2.6.4.9,2.7,2.1,4.1,2.4A10.269,10.269,0,0,0,81.1,64.7Z",
    fill: "#2c355e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M77.4,60.8c.3.2.7.5.7.8a3.325,3.325,0,0,1-.2,1.4c-.1.1-.5.1-.8.2a1.083,1.083,0,0,1-1.2-.5v-.1a.52.52,0,0,0-.4-.2l-1.7.1a.52.52,0,0,0-.4.2h0a1.319,1.319,0,0,1-1.4.5l-.6-.2a4.831,4.831,0,0,1,.1-1.6c0-.4.4-.7.8-.8C73,60.4,76.1,60,77.4,60.8Z",
    fill: "#f5caa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M72.6,61.5s2.5,1,4.1-.1",
    fill: "none",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M84.6,50.3c-3-.6-8.1.2-8.1.2a8.446,8.446,0,0,1-3.6.1,22.383,22.383,0,0,0-8.2-.3.639.639,0,0,0-.6.9c-.1.6.3.6.3.6.5.2.7,2.3.7,2.3.3,2.1.8,2.2.8,2.2,2.6,1.5,5.7.2,5.7.2,1.5-.4,1.9-3.8,1.9-3.8.1-.8,1-.7,1-.7,1,0,.9.6.9.6L76,55a2.367,2.367,0,0,0,2.1,1.8c3,.6,4.2-.1,4.2-.1,1.5-.2,1.5-2.2,1.5-2.2.2-2.4.6-2.5.6-2.5.7-.3.5-.7.5-.7C85,50.2,84.6,50.3,84.6,50.3Zm-12,3.5a2.807,2.807,0,0,1-1.9,2.4s-2.9.7-4.4-.4c0,0-.6-.2-.7-2.4,0,0-.4-2.4,1-2.7,0,0,4.9-.6,6,.8C72.7,51.5,73.1,51.6,72.6,53.8Zm10.6-.5c-.1,2.2-.7,2.4-.7,2.4-1.5,1.1-4.4.4-4.4.4-1.7-.3-1.9-2.4-1.9-2.4-.5-2.1-.1-2.3-.1-2.3,1.1-1.4,6-.8,6-.8C83.6,51,83.2,53.3,83.2,53.3Z",
    fill: "#161b43"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_123",
    "data-name": "Line 123",
    y1: 15.9,
    x2: 0.7,
    transform: "translate(56.8 86.3)",
    fill: "none",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_124",
    "data-name": "Line 124",
    y1: 15.9,
    x2: 0.7,
    transform: "translate(89.7 86.3)",
    fill: "none",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M45.6,104.3h0a9.686,9.686,0,0,0-.3,10.7c2.5,4.1,5.6,2.9,12.3,1.9l24.7-5.4a1.556,1.556,0,0,0,.9-1.8L80.1,97.2l-32,5.5A3.8,3.8,0,0,0,45.6,104.3Z",
    fill: "#fff",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M68.5,97.3s-6.8-1.9-9.1-.9c-2.2,1-4.7,5.1-4.7,5.1s6.8,1.2,11.1,3.4Z",
    fill: "#f5caa2",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M79.1,98.2s6.8-1.9,9.1-.9c2.2,1,4.7,5.1,4.7,5.1s-6.8,1.2-11.1,3.4Z",
    fill: "#f5caa2",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M101.8,103h0a9.686,9.686,0,0,1,.3,10.7c-2.5,4.1-5.6,2.9-12.3,1.9l-24.7-5.4a1.556,1.556,0,0,1-.9-1.8L67.3,96l32,5.5A3.283,3.283,0,0,1,101.8,103Z",
    fill: "#fff",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleNurse);
export default __webpack_public_path__ + "static/media/male-nurse.20e82e33ae6d3bd1d00af61d46319d63.svg";
export { ForwardRef as ReactComponent };